class CollectionViewToggle extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.collection-page');
    this.buttons = Array.from(this.querySelectorAll('[data-collection-view]'));
    this.storageKey = 'converto:collection-view';

    if (!this.section || this.buttons.length === 0) return;

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);

    let initialView = this.dataset.defaultView || 'grid';
    try {
      const savedView = window.localStorage.getItem(this.storageKey);
      if (savedView === 'grid' || savedView === 'list') initialView = savedView;
    } catch (error) {
      // Le stockage peut être désactivé : la vue par défaut reste fonctionnelle.
    }

    this.setView(initialView, false);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-collection-view]');
    if (!button || !this.contains(button)) return;
    this.setView(button.dataset.collectionView, true);
  }

  setView(view, persist) {
    const nextView = view === 'list' ? 'list' : 'grid';
    this.section.dataset.collectionView = nextView;

    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.collectionView === nextView));
    });

    if (persist) {
      try {
        window.localStorage.setItem(this.storageKey, nextView);
      } catch (error) {
        // La préférence est simplement limitée à la page en cours.
      }
    }
  }
}

if (!customElements.get('collection-view-toggle')) {
  customElements.define('collection-view-toggle', CollectionViewToggle);
}
